export function removeMask(value: string): string {
  return value.replace(/[-./]/gi, '');
}

export const handleChangeDocumentCnpj = (
  e: React.ChangeEvent<HTMLInputElement>,
  setDocument: any,
  setRecaptchaValue: any,
) => {
  const doc = e.target.value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
  setDocument(doc);
  setRecaptchaValue('');
};
